<template>
  <div id="vue-app">
      <div class="container mt">
          <div tabindex="0" role="alert" class="error-container" id="error">
            <div class="error" v-if="error">
                <p>{{ errorContent }}</p>
            </div>
            </div>
      <div tabindex="0" role="alert" class="confirmation-container" id="confirmation">
          <div class="confirmation" v-if="confirmation">
                <h3>Thank you!</h3>
                <p>Your application has been submitted. You will receive a confirmation email shortly regarding next steps.</p>
                <router-link class="btn btn-primary" to="/available-properties/applications">View Application Status</router-link>          
        </div>
      </div>

          <div class="additional-files" v-if="!confirmation" >
              <form class="application" enctype="multipart/form-data" >
                <h2>Additional Files</h2>
                <div class="form-item file-upload" v-if="displayFields.indexOf('funds_table') !== -1" required v-focus>
                    <p class="warning" role="alert">A Sources and Uses of Funds Table attachment is required</p>
                    <label for="funds_table">Please fill out and upload the attached Sources and Uses of Funds Table, or attach your own if you already have one:<br>
                    <a href="/assets/files/Commercial-Costs-Funding-rev.07.25.19.pdf" target="_blank"><i class="fa fa-chevron-right"></i>Sources and Uses of Funds Table PDF</a></label>
                    <input type="file" id="funds_table" name="funds_table" v-on:change="storeFiles($event.target.name, $event.target.files)">
                </div>

                <div class="form-item file-upload" v-if="displayFields.indexOf('costs_table') !== -1" required v-focus>
                    <p class="warning" role="alert">A Costs Table is required</p>
                    <label for="costs_table" class="infoLabel">Please fill out and upload the attached Costs Table, or attach your own if you already have one:</label>
                    <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                        <div class="info large">These are estimated costs based on exterior observations and best guess as to costs. You can also check for existing code orders at <a href="http://cagismaps.hamilton-co.org/PropertyActivity/cagisreport" target="_blank">Cagis Property Activity Report</a>.  Once your application has been screened, you will be provided access to the interior of the property.  Following that site visit, you may adjust your construction estimates and choose whether or not you want to move forward with your application.</div><br>
                    </div>
                    <a href="/assets/files/SF-Costs-Funding.pdf" target="_blank"><i class="fa fa-chevron-right"></i>Costs Table PDF</a><br>
                    <input type="file" id="costs_table" name="costs_table" v-on:change="storeFiles($event.target.name, $event.target.files)">
                </div>

                <div class="form-item file-upload" v-if="displayFields.indexOf('proof_of_funds') !== -1" required>
                    <p class="warning" role="alert">A Proof of Funds attachment is required</p>
                    <label for="proof_of_funds" class="infoLabel">Please upload a document displaying proof of available funds</label>
                    <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                        <div class="info large">Examples include a bank statement or financing letter.  This information is necessary so the Landbank can verify that an applicant has the financial means to complete the project.</div>
                    </div><br>
                    <input type="file" id="proof_of_funds" name="proof_of_funds" v-on:change="storeFiles($event.target.name, $event.target.files)">
                </div>

                <div class="form-item file-upload" v-if="displayFields.indexOf('experience') !== -1" required>
                    <label for="experience" class="infoLabel">Please upload files showing experience with construction or property rehabilitation</label>
                    <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                        <div class="info large">An example would be construction photos</div>
                    </div><br>
                    <input type="file" id="experience" name="experience" v-on:change="storeFiles($event.target.name, $event.target.files)" multiple>
                </div>

                <div class="form-item file-upload" v-if="displayFields.indexOf('other') !== -1" required>
                    <label for="other" class="infoLabel">Other Files You Would Like to Include</label>
                    <!-- <div class="infoLabel">
                        <button class="fas fa-info-circle" v-on:click="displayTooltip($event)"></button>
                        <div class="info large">Examples include a bank statement or financing letter.  This information is necessary so the Landbank can verify that an applicant has the financial means to complete the project.</div>
                    </div> -->
                    <br>
                    <input type="file" id="other" name="other" v-on:change="storeFiles($event.target.name, $event.target.files)" multiple>
                </div>

            </form>
            <div class="application-button-container">
                <button class="btn btn-primary" v-on:click="send">Submit Application</button>
                <double-bounce v-if="loading"></double-bounce>

            </div>
          </div>

          
         
            
        </div>
        </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';


export default {
  name: 'ApplicationFinish',
 components: {
    DoubleBounce,
  },
  data() {
    return {
        error: false,
        errorContent: '',
        confirmation: false,
        costs_table: '',
        proof_of_funds: '',
        funds_table: '',
        experience: '',
        other: '',
        loading: false,
        applicationType: this.$route.query.applicationType,
        
    }
  },
  created() {
        window.scrollTo(0,0);
      if (this.displayFields.length == 0) {
          this.send();
      }
      

  },
  computed: {
      displayFields() {
            // Check application type
            if (this.applicationType == 'Single Family Home Development') {
                return ['costs_table', 'proof_of_funds', 'experience', 'other'];

            } else if (this.applicationType == 'Commercial Development') {
                return ['proof_of_funds', 'funds_table', 'experience', 'other'];
            } else if (this.applicationType == 'Gardens and Greens') {
                return ['other']
            } else {
                return []
            }
      },
  },
  methods: {
      displayTooltip(event) {
        this.$parent.displayTooltip(event);
      },
      storeFiles(fieldName, fileList) {
        this.$set(this, fieldName, fileList);
      },
      send() {
          // Reset errors
           this.$set(this, 'error', false);
            $('.form-item').each(function() {
                $(this).removeClass('warning');
            })

            if (this.applicationType == 'Lot-to-Yard'){
                this.$set(this, 'loading', true);

                // Submit Application
                axios.post('/wp-json/HCLRC/v1/submit-public-application', {
                    'application_id': this.$route.params.app_id,
                }).then(res => {
                    this.$set(this, 'loading', false);

                    if (res.data.data.status == 'ERROR') {
                        this.$set(this, 'error', true);
                        this.$set(this, 'errorContent', 'There was a problem with your submission.');
                        this.$set(this, 'loading', false);
                    }  else {
                        this.$set(this, 'confirmation', true);
                        window.scrollTo(0,0);
                        document.getElementById('confirmation').focus();
                    }
                        
                })
                .catch(function (error) {
                    // if an error occurs, print that error
                    console.log(error);

                });

            } else {

          // Get required fields by application type
          var requiredFields;
            if (this.applicationType == 'Single Family Home Development') {
                var requiredFields = {
                    'costs_table': this.costs_table,
                    'proof_of_funds': this.proof_of_funds,
                }
            } else if (this.applicationType == 'Commercial Development') {
                var requiredFields = {
                    'proof_of_funds': this.proof_of_funds,
                    'funds_table': this.funds_table,
                    'experience': this.experience,
                }
            } else {
                var requiredFields = {}
            }
            
            // Check that they are uploaded, show error if not
            for (var item in requiredFields) {

                if (requiredFields[item] == '') {
                    this.$set(this, 'error', true);
                    this.$set(this, 'errorContent', 'There was an error with your submission. Please check that you have uploaded all required files.');
                    window.scrollTo(0,0);
                    document.getElementById('error').focus();

                    // Highlight field
                    $('#' + item).closest('.form-item').addClass('warning');

                }
                    
            }

            // If all required fields are uploaded, submit api request and show confirmation
            if (!this.error) {

                // Set loader 
                this.$set(this, 'loading', true);

                // check if token is still valid
                axios.post('/wp-json/HCLRC/v1/check-user/').then((response) => {

                    if ( response.data.loggedIn == false ) {
                        this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});

                    } else {
                         // Get the files and set them as appropriate objects for PHP                
                        // Go through each field and add to the files array if there's a file to submit
                        var files = [];

                        for (var item of this.displayFields) {
                            let formData = null;

                            if (item == 'costs_table') {
                                formData = new FormData();
                                formData.append('application_id', this.$route.params.app_id);
                                formData.append('file', this.costs_table[0]);
                                formData.append('public_application_upload_type', 'Costs Table');
                                files.push(formData);
                            } else if (item == 'proof_of_funds') {
                                formData = new FormData();
                                formData.append('application_id', this.$route.params.app_id);
                                formData.append('file', this.proof_of_funds[0]);
                                formData.append('public_application_upload_type', 'Proof of Funds');
                                files.push(formData);
                            } else if (item == 'funds_table') {
                                formData = new FormData();
                                formData.append('application_id', this.$route.params.app_id);
                                formData.append('file', this.funds_table[0]);
                                formData.append('public_application_upload_type', 'Sources and Uses of Funds Table');
                                files.push(formData);
                            } else if (item == 'experience') {
                                if (this.experience != '') {
                                    for (var i = 0; i < this.experience.length; i++) {
                                        formData = new FormData();
                                        formData.append('application_id', this.$route.params.app_id);
                                        formData.append('file', this.experience[i]);
                                        formData.append('public_application_upload_type', 'Files proving Experience');
                                        files.push(formData);
                                    }
                                }
                            } else {
                                if (this.other != '') {
                                    for (var i = 0; i < this.other.length; i++) {
                                        formData = new FormData();
                                        formData.append('application_id', this.$route.params.app_id);
                                        formData.append('file', this.other[i]);
                                        formData.append('public_application_upload_type', 'Other');
                                        files.push(formData);
                                    }
                                    
                                }
                            }
                        }
                        // Submit each of the files to the API
                        var count = 1;
                        for (var file of files) {
                            axios.post('/wp-json/HCLRC/v1/public-application-upload', file
                            ).then(res => {
                                console.log('file response', res);

                                // 8/13/2020 Turned off error check for application upload to make sure applications 
                                // are marked as received regardless and HCLRC can follow-up
                                // if (res.data.data.status == 'ERROR') {
                                //     this.$set(this, 'error', true);
                                //     this.$set(this, 'errorContent', 'There was a problem with your submission.');
                                //     this.$set(this, 'loading', false);

                                // } 

                                if (count == files.length) {
                                    // Finally, submit the application
                                        // If there are no errors in the submissions
                                        // 8/13/2020 turned off check for errors 
                                        // if (!this.error) {

                                            // Submit Application
                                            axios.post('/wp-json/HCLRC/v1/submit-public-application', {
                                                'application_id': this.$route.params.app_id,
                                            }).then(res => {
                                                this.$set(this, 'loading', false);

                                                if (res.data.data.status == 'ERROR') {
                                                    this.$set(this, 'error', true);
                                                    this.$set(this, 'errorContent', 'There was a problem with your submission.');
                                                }  else {
                                                    this.$set(this, 'confirmation', true);
                                                    window.scrollTo(0,0);
                                                    document.getElementById('confirmation').focus();
                                                }
                                            })
                                            .catch(function (error) {
                                                // if an error occurs, print that error
                                                console.log(error);

                                            });

                                        // }
                                }

                                count++;
                                    
                            })
                            .catch(function (error) {
                                // if an error occurs, print that error
                                console.log(error);

                            });
                        }
                    }
                
                });

            } 
        }
    }
      
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.form-container {
    text-align: center;
    a.btn {
        text-transform: none;
        font-size: 1rem;
    }
}
.application-button-container {
    .spinner {
        margin-bottom: 0 !important;
        margin-left: 1rem;
    }
}
.confirmation {
    text-align: center;
}


</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationFinish.vue